<template>
  <v-app>
    <v-toolbar color="primary" dark app>
      <v-toolbar-title>PICO2 Portal</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
    </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-snackbar v-model="snackBar.show" bottom>
      {{ snackBar.message }}
      <v-btn color="primary" flat @click="closeSnackBar()">
        dismiss
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>

import { isLoggedIn } from '@/services/AuthService'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  computed: mapGetters({
    snackBar: 'snackBar'
  }),
  methods: {
    isLoggedIn,

    closeSnackBar () {
      this.$store.dispatch('dissmissSnackBar')
    }
  },

  created () {
    if (isLoggedIn()) {
      this.$store.dispatch('loadIngredientList')
    }
  }
}
</script>

<style lang="scss">

html {
  height: 100%;
  width: 100%;
}

body {
  height: 100%;
  width: 100%;
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  background: white;
}

.v-content{
  background: white;
}

#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
